export * as redirects from '@wix/auto_sdk_redirects_redirects/meta';
